import { ON_BETA_DASHBOARD_TIME_FILTER_CHANGE } from '../actions.js';

const initialState = 'mtd';

export default (state = initialState, action) => {
  if (action.type === ON_BETA_DASHBOARD_TIME_FILTER_CHANGE) {
    return action.payload;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers/selected-time.js